import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cloneDeep, get, isEmpty } from "lodash";
import { useStoreState } from "pullstate";
import Store from "../../../../utils/Store";
import { useCopilotAction } from "@copilotkit/react-core";
import useWorkspaceTagSettingsService from "../../../CustomTagsManagement/services/workspaceTagSettingsService";
import { useEffect, useState } from "react";
import AddCustomFilterTag from "../../AddCustomFilterTag";
import { getLogicOptions } from "../../../PatientTags/constants";
import { useAuth } from "@qure/qure-auth";
var useAddCustomFiltersWithAI = function useAddCustomFiltersWithAI(_ref) {
  var filtersData = _ref.filtersData,
    selectedWorkspaceId = _ref.selectedWorkspaceId,
    isDisabled = _ref.isDisabled,
    applyFilters = _ref.applyFilters,
    setFiltersData = _ref.setFiltersData;
  var _useState = useState({}),
    filterTags = _useState[0],
    setFilterTags = _useState[1];
  var _useWorkspaceTagSetti = useWorkspaceTagSettingsService(selectedWorkspaceId),
    customFieldsList = _useWorkspaceTagSetti.data;
  var customFields = cloneDeep(customFieldsList);
  var getCustomTagParameters = function getCustomTagParameters(customFields) {
    var parameters = customFields === null || customFields === void 0 ? void 0 : customFields.map(function (tag) {
      var baseParam = {
        name: tag.tag,
        description: tag.description || "No description provided",
        required: false
      };
      if (tag.tag_type === "multi_dropdown") {
        var _tag$properties;
        return _objectSpread(_objectSpread({}, baseParam), {}, {
          type: "string[]",
          "enum": tag === null || tag === void 0 || (_tag$properties = tag.properties) === null || _tag$properties === void 0 ? void 0 : _tag$properties.options
        });
      } else if (tag.tag_type === "user") {
        var _tag$properties2;
        return _objectSpread(_objectSpread({}, baseParam), {}, {
          type: "string",
          "enum": tag === null || tag === void 0 || (_tag$properties2 = tag.properties) === null || _tag$properties2 === void 0 ? void 0 : _tag$properties2.options
        });
      } else if (tag.tag_type === "boolean") {
        return _objectSpread(_objectSpread({}, baseParam), {}, {
          type: "boolean"
        });
      } else if (tag.tag_type === "integer" || tag.tag_type === "float") {
        var logicOptions = getLogicOptions("integer");
        return _objectSpread(_objectSpread({}, baseParam), {}, {
          // type: "number" as const,
          type: "object",
          attributes: [{
            name: "value",
            type: "number",
            description: "The value to filter by"
          }, {
            name: "logic",
            type: "string",
            "enum": logicOptions.map(function (option) {
              return option.value;
            }),
            description: "The logic to filter by. The mapping is ".concat(JSON.stringify(logicOptions))
          }]
        });
      } else if (tag.tag_type === "date") {
        var _logicOptions = getLogicOptions("date");
        return _objectSpread(_objectSpread({}, baseParam), {}, {
          // type: "number" as const,
          type: "object",
          attributes: [{
            name: "value",
            type: "string[]",
            description: "The array of dates to filter by. It can be a single date or a range of dates. The format is YYYY-MM-DD"
          }, {
            name: "logic",
            type: "string",
            "enum": _logicOptions.map(function (option) {
              return option.value;
            }),
            description: "The logic to filter by. The mapping is ".concat(JSON.stringify(_logicOptions))
          }]
        });
      } else {
        return _objectSpread(_objectSpread({}, baseParam), {}, {
          type: "string"
        });
      }
    });
    return parameters;
  };
  useEffect(function () {
    if (!isEmpty(filtersData.custom_tags)) {
      var _filterTags = filterTags;
      filtersData.custom_tags.forEach(function (field) {
        var _cloneDeep;
        var newField = (_cloneDeep = cloneDeep(customFieldsList)) === null || _cloneDeep === void 0 ? void 0 : _cloneDeep.find(function (_field) {
          return _field.id == field.tag_id;
        });
        _filterTags[field.tag_id] = _objectSpread(_objectSpread({}, newField), {}, {
          value: field.value
        });
      });
      setFilterTags(_filterTags);
    } else {
      setFilterTags({});
    }
  }, [filtersData.custom_tags, customFieldsList]);
  var formatValue = function formatValue(value, field) {
    var _field$properties;
    if ((_field$properties = field.properties) !== null && _field$properties !== void 0 && _field$properties.options) {
      var _field$properties3;
      if (Array.isArray(value)) {
        var values = value.map(function (option) {
          var _field$properties2;
          return field === null || field === void 0 || (_field$properties2 = field.properties) === null || _field$properties2 === void 0 || (_field$properties2 = _field$properties2.options) === null || _field$properties2 === void 0 ? void 0 : _field$properties2.find(function (o) {
            return o.trim().toLowerCase() === option.trim().toLowerCase();
          });
        });
        return values.filter(function (v) {
          return v !== undefined;
        });
      }
      var formattedValue = field === null || field === void 0 || (_field$properties3 = field.properties) === null || _field$properties3 === void 0 || (_field$properties3 = _field$properties3.options) === null || _field$properties3 === void 0 ? void 0 : _field$properties3.find(function (option) {
        return option.trim().toLowerCase() === value.trim().toLowerCase();
      });
      return formattedValue ? formattedValue : "";
    }
    return value;
  };
  useCopilotAction({
    name: "addCustomFilters",
    description: "Add custom filters to the current workspace",
    parameters: getCustomTagParameters(customFields),
    available: isDisabled ? "disabled" : "enabled",
    handler: function handler(props) {
      var selectedTags = [];
      var _loop = function _loop() {
          var _customFields$find;
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];
          if (!key || typeof key !== "string") {
            console.warn("Invalid tag key:", key);
            return 0; // continue
          }
          if (value === undefined || value === null) {
            console.warn("Invalid tag value for key:", key);
            return 0; // continue
          }
          var tagId = customFields === null || customFields === void 0 || (_customFields$find = customFields.find(function (tag) {
            return tag.tag.toLowerCase() === key.toLowerCase();
          })) === null || _customFields$find === void 0 ? void 0 : _customFields$find.id;
          if (!tagId) {
            console.warn("Tag not found:", key);
            return 0; // continue
          }
          var _tag = customFields === null || customFields === void 0 ? void 0 : customFields.find(function (field) {
            return field.id === tagId;
          });
          var tag = {
            tag_id: tagId,
            field: _tag
          };
          if (_tag.tag_type === "integer" || _tag.tag_type === "float") {
            tag.response = value.value;
            tag.logic = value.logic;
          } else if (_tag.tag_type === "date") {
            var _value$value;
            tag.response = ((_value$value = value.value) === null || _value$value === void 0 ? void 0 : _value$value.length) > 1 ? value.value : value.value[0];
            tag.logic = value.logic;
          } else {
            tag.response = formatValue(value, _tag);
          }
          if (tag) {
            selectedTags.push(tag);
          }
        },
        _ret;
      for (var _i = 0, _Object$entries = Object.entries(props); _i < _Object$entries.length; _i++) {
        _ret = _loop();
        if (_ret === 0) continue;
      }
      var assistantIdentifier = Math.random().toString(36).substring(2, 10);
      Store.update(function (s) {
        s.lastAssitantMessageId = assistantIdentifier;
      });
      return {
        selectedTags: selectedTags,
        filtersData: filtersData,
        assistantIdentifier: assistantIdentifier
      };
    },
    followUp: false,
    render: function render(_ref2) {
      var status = _ref2.status,
        result = _ref2.result;
      if (status === "complete") {
        return /*#__PURE__*/React.createElement(AddCustomFilterTag, {
          result: result,
          customFields: customFields,
          filtersData: result === null || result === void 0 ? void 0 : result.filtersData,
          setFiltersData: setFiltersData,
          applyFilters: applyFilters
        });
      }
    }
  });
};
var useAddCustomFilters = function useAddCustomFilters(_ref3) {
  var filtersData = _ref3.filtersData,
    selectedWorkspaceId = _ref3.selectedWorkspaceId,
    applyFilters = _ref3.applyFilters,
    setFiltersData = _ref3.setFiltersData;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        areFrontendToolsEnabled: s.areFrontendToolsEnabled
      };
    }),
    areFrontendToolsEnabled = _useStoreState.areFrontendToolsEnabled;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var isAIAssistantEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], false);
  var isDisabled = !isAIAssistantEnabled || !userInfo || !areFrontendToolsEnabled;
  return useAddCustomFiltersWithAI({
    filtersData: filtersData,
    selectedWorkspaceId: selectedWorkspaceId,
    isDisabled: isDisabled,
    applyFilters: applyFilters,
    setFiltersData: setFiltersData
  });
};
export default useAddCustomFilters;